import { Component, input } from '@angular/core';

import { BlockTextComponent, WysiswgBlockData } from '@camelot/wysiswyg';

import { Communication, CommunicationParticipantExtended } from '../../../services/dto/communication';

@Component({
  selector: 'cam-communication-message-chat',
  templateUrl: './message-chat.component.html',
  styleUrls: ['./message-chat.component.scss'],
  imports: [BlockTextComponent],
})
export class MessageChatComponent {
  conversationParticipants = input.required<CommunicationParticipantExtended[]>();

  communication = input.required<Communication>();

  public getBody(): WysiswgBlockData[] {
    return JSON.parse(this.communication().body);
  }
}
